import { Skeleton } from '@iwoca/orion';

import { FundingRequirementsPageShell } from '../../../../components/FundingRequirementsPageShell';

export const FundingRequirementsPageLoading = () => (
    <div data-testid="funding-requirements-page-loading">
        <FundingRequirementsPageShell
            sidePanel={
                <div className="space-y-xl opacity-20">
                    <Skeleton className="h-[32px] w-[200px]" />
                    <div className="space-y-s">
                        <Skeleton className="h-[20px] w-[160px]" />
                        <Skeleton className="h-[40px] w-[220px]" />
                    </div>
                    <div className="space-y-m border-t border-secondary-20 pt-xl">
                        <Skeleton className="h-[20px] w-full" />
                        <Skeleton className="h-[20px] w-full" />
                        <Skeleton className="h-[20px] w-full" />
                    </div>
                </div>
            }
            progressIndicator={<Skeleton className="h-[40px] w-full" />}
            mainContent={
                <div className="mx-auto max-w-[600px] space-y-xl py-2xl">
                    <div className="space-y-s">
                        <Skeleton className="h-[28px] w-[250px]" />
                        <Skeleton.Text count={2} lastLineWidth={80} />
                    </div>
                    <div className="border-t border-secondary-90">
                        {Array.from({ length: 5 }, (_, i) => (
                            <div
                                key={i}
                                className="flex items-center justify-between border-b border-secondary-90 p-xl"
                            >
                                <Skeleton className="h-[20px] w-[200px]" />
                                <Skeleton className="h-[20px] w-[60px]" />
                            </div>
                        ))}
                    </div>
                </div>
            }
        />
    </div>
);
